import * as React from "react";

import "./Icon.css";

const SvgTagIcon = ({ width, height, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
    viewBox="0 0 47.96 47.96"
    width={width || undefined}
    height={height ? height : "auto"}
    fill="currentColor"
    {...props}
    className={`svg-icon shake-two-icon-target ${props.className || ""}`}
    style={{
      transformOrigin: "center",
      ...props.style,
      ...(width ? { width: width } : {}),
      ...(height ? { height: height } : {}),
    }}
  >
    <path d="M43.4 4.56C39.27.42 34.18-1.2 32 .94L.27 32.71a1 1 0 0 0-.27.75l1.18 12.08a1 1 0 0 0 .33.63l.48.4a1 1 0 0 0 .52.22L14.5 48a.94.94 0 0 0 .75-.27L47 15.92c2.16-2.14.54-7.22-3.6-11.36m-9.4.95 8.43 8.43a.94.94 0 0 1 0 1.32L18.67 39a.94.94 0 0 1-1.33 0l-8.42-8.38a.94.94 0 0 1 0-1.33L32.7 5.51a.94.94 0 0 1 1.3 0" />
    <path d="M10.64 29.963 33.626 6.975l1.5 1.499-22.989 22.988zM13.63 32.956l15.083-15.082 1.5 1.499-15.084 15.082zM16.509 35.827l18.13-18.13 1.5 1.499-18.131 18.13z" />
  </svg>
);
export default SvgTagIcon;
